/**
 * Text truncation utilities for UI components
 */

/**
 * Truncate text to a specified length and add ellipsis
 * @param text - Text to truncate
 * @param maxLength - Maximum length before truncation
 * @returns Truncated text with ellipsis if needed
 */
export function truncateText(text: string, maxLength: number): string {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}...`;
}

/**
 * Check if text needs truncation
 * @param text - Text to check
 * @param maxLength - Maximum length threshold
 * @returns True if text exceeds max length
 */
export function needsTruncation(text: string, maxLength: number): boolean {
  return !!(text && text.length > maxLength);
}

/**
 * Get truncated text for display with full text for tooltip
 * @param text - Text to process
 * @param maxLength - Maximum length before truncation
 * @returns Object with display text and whether tooltip is needed
 */
export function getTruncatedDisplay(text: string, maxLength: number): {
  displayText: string;
  fullText: string;
  needsTooltip: boolean;
} {
  const needsTooltip = needsTruncation(text, maxLength);
  return {
    displayText: needsTooltip ? truncateText(text, maxLength) : text,
    fullText: text,
    needsTooltip,
  };
}
